import styled from "styled-components";
import { StyledButton } from "../../styles/styledButton";
import { StyledHomePageSectionBlock } from "../styledHomePage";

import question from "../../../assets/images/home-page/question.png";
import hand from "../../../assets/images/home-page/hand.png";

export const StyledHomePageStillHaveQuestionsWrapper = styled.div`
  padding: 30px 0;
  background-color: #A4A8CD;

  ${StyledButton} {
    padding: 8px 30px;
    font-size: 18px;
    border-radius: 10px;
    @media screen and (max-width: 768px) {
      width: 60px;
      height: 60px;
      background-image: url(${hand});
      background-size: 75px;
      background-repeat: no-repeat;
      background-position: center -10px;
      background-color: #ffffff;
      border-radius: 50%;
      border: none;
      span {
        display: none;
      }

      &:hover {
        background-position: center -5px;
      }
    }
  }
`;

export const StyledStillHaveQuestionsContainer = styled.div`
  max-width: 992px;
  width: 100%;
  margin: 0 auto;
  padding: 0 15px;
  display: grid;
  grid-template-columns: 90px 1fr max-content;
  align-items: center;
  justify-content: space-between;
  grid-gap: 50px;
  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr 60px;
  }
  @media screen and (max-width: 576px) {
    min-width: 285px;
    max-width: 70%;
    padding: 0;
    grid-gap: 15px;
  }
`;

export const StyledHomePageHaveQuestionsBlock = styled(StyledHomePageSectionBlock)`
  padding: 0 15px;  
  position: relative;
  
  @media(min-width: 992px) {
    &:before {
      width: 100%;
      max-width: 495px;
      height: 495px;
      content: '';
      position: absolute;
      top: -170px;
      left: -360px;
      border-radius: 50%;
      background: rgba(23, 37, 160, 0.15);
      filter: blur(100px);
      user-select: none;
    }
    @media(max-width: 576px) {
      &:before {
        width: 100%;
        max-width: 495px;
        height: 495px;
        content: '';
        position: absolute;
        top: -170px;
        left: -360px;
        border-radius: 50%;
        background: rgba(23, 37, 160, 0.15);
        filter: blur(50px);
        user-select: none;
      }
  }
`
export const StyledStillHaveQuestionsImage = styled.div`
  width: 90px;
  height: 90px;
  background-image: url(${question});
  background-size: 75%;
  background-repeat: no-repeat;
  background-position: center center;
  background-color: #ffffff;
  border-radius: 50%;
  transition: all .3s ease;
  cursor: pointer;
  &:hover {
    background-size: 90%;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.15);
  }
  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const StyledStillHaveQuestionsText = styled.div`
  color: #ffffff;
  h5 {
    padding-bottom: 15px;
    font-size: 30px;
    font-weight: 700;
    line-height: 36px;
  }
  p {
    font-size: 16px;
    font-weight: 300;
    line-height: 19px;
  }
  @media screen and (max-width: 576px) {
    h5 {
      padding-bottom: 10px;
      font-size: 20px;
    }
    p {
      font-size: 14px;
    }
  }
`;